import { all, takeLatest, call, fork, put, select, take } from "redux-saga/effects";
import { messages, success, deleteData } from "../../components/messageBox"
import * as types from "../../constants/actionTypes";
import { setLoader } from "./actions";
import moment from 'moment';
import Config from "../../service/Config";
import Endpoint from "../../service/Endpoint";
import { GET, POST, PUT } from "../../service/api";
import { Header } from '../../constants/headers'

const getStateModuleReport = state => state.ModuleReport;

export function* reportICDPasien(params) {
    try {
        yield put(setLoader(true));
        const _id = JSON.parse(localStorage.getItem('UserData')).f_id_klinik;
        const _body = {
            "id": _id,
            "month": params.value,
        }

        const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_REPORT_LIST_ICD_PASIEN_POST, _body);

        if(response.acknowledge == 1){
            yield put({ type: types.MODULE_REPORT_LISTDATA_ICD_PASIEN_SUCCESS, value: response.data})
        }else{
            messages("Error", "Gagal memuat data", "error", false, false);
        }

        yield put(setLoader(false));
    } catch (error) {
        yield put(setLoader(false));
        messages("Error", error, "error", false, false);
    }
}

export function* reportKunjunganPasien(params) {
    try {
        yield put(setLoader(true));
        const _id = JSON.parse(localStorage.getItem('UserData')).f_id_klinik;
        const _body = {
            "id": _id,
            "days": params.value,
        }

        const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_REPORT_LIST_KUNJUNGAN_PASIEN_POST, _body);

        if(response.acknowledge == 1){
            yield put({ type: types.MODULE_REPORT_LISTDATA_KUNJUNGAN_PASIEN_SUCCESS, value: response.data})
        }else{
            messages("Error", "Gagal memuat data", "error", false, false);
        }

        yield put(setLoader(false));
    } catch (error) {
        yield put(setLoader(false));
        messages("Error", error, "error", false, false);
    }
}

export default function* rootSaga() {
    yield all([
        takeLatest(types.MODULE_REPORT_LISTDATA_ICD_PASIEN, reportICDPasien),
        takeLatest(types.MODULE_REPORT_LISTDATA_KUNJUNGAN_PASIEN, reportKunjunganPasien),
    ]);
}
